// Comprehensive list of US banks with tier classification
// Based on the credit guide's banking tier system

export const banks = [
  // Tier 1 - National Premium Banks
  { name: 'Chase Bank', tier: 1 },
  { name: 'JPMorgan Chase', tier: 1 },
  { name: 'JPMorgan Chase Bank', tier: 1 },
  { name: 'JPMCB', tier: 1 },
  { name: 'American Express', tier: 1 },
  { name: 'Bank of America', tier: 1 },
  { name: 'Wells Fargo', tier: 1 },
  { name: 'US Bank', tier: 1 },
  { name: 'U.S. Bank', tier: 1 },
  { name: 'Citibank', tier: 1 },
  { name: 'Citi', tier: 1 },
  { name: 'Goldman Sachs', tier: 1 },
  { name: 'Goldman Sachs/Apple Card', tier: 1 },
  { name: 'Apple Card', tier: 1 },
  
  // Tier 2 - Regional & Strategic Banks
  { name: 'Capital One', tier: 2 },
  { name: 'Discover', tier: 2 },
  { name: 'Discover Bank', tier: 2 },
  { name: 'PNC Bank', tier: 2 },
  { name: 'PNC', tier: 2 },
  { name: 'Truist Bank', tier: 2 },
  { name: 'Truist', tier: 2 },
  { name: 'Citizens Bank', tier: 2 },
  { name: 'Citizens', tier: 2 },
  { name: 'Navy Federal Credit Union', tier: 2 },
  { name: 'Navy Federal', tier: 2 },
  { name: 'NFCU', tier: 2 },
  { name: 'PenFed Credit Union', tier: 2 },
  { name: 'PenFed', tier: 2 },
  { name: 'TD Bank', tier: 2 },
  { name: 'TD', tier: 2 },
  { name: 'Regions Bank', tier: 2 },
  { name: 'Regions', tier: 2 },
  { name: 'Fifth Third Bank', tier: 2 },
  { name: 'Fifth Third', tier: 2 },
  { name: 'KeyBank', tier: 2 },
  { name: 'Key Bank', tier: 2 },
  { name: 'M&T Bank', tier: 2 },
  { name: 'M&T', tier: 2 },
  { name: 'Huntington Bank', tier: 2 },
  { name: 'Huntington', tier: 2 },
  { name: 'BB&T', tier: 2 },
  { name: 'BBT', tier: 2 },
  { name: 'SunTrust', tier: 2 },
  { name: 'Ally Bank', tier: 2 },
  { name: 'Ally', tier: 2 },
  { name: 'USAA', tier: 2 },
  { name: 'State Farm Bank', tier: 2 },
  { name: 'State Farm', tier: 2 },
  { name: 'First National Bank', tier: 2 },
  { name: 'FNB', tier: 2 },
  { name: 'Comerica Bank', tier: 2 },
  { name: 'Comerica', tier: 2 },
  { name: 'Zions Bank', tier: 2 },
  { name: 'Zions', tier: 2 },
  { name: 'BMO Harris Bank', tier: 2 },
  { name: 'BMO Harris', tier: 2 },
  { name: 'BMO', tier: 2 },
  { name: 'First Citizens Bank', tier: 2 },
  { name: 'First Citizens', tier: 2 },
  { name: 'Associated Bank', tier: 2 },
  { name: 'Associated', tier: 2 },
  { name: 'Webster Bank', tier: 2 },
  { name: 'Webster', tier: 2 },
  { name: 'Frost Bank', tier: 2 },
  { name: 'Frost', tier: 2 },
  { name: 'Cathay Bank', tier: 2 },
  { name: 'East West Bank', tier: 2 },
  { name: 'East West', tier: 2 },
  
  // Tier 3 - Tactical Options / Subprime
  { name: 'Synchrony Bank', tier: 3 },
  { name: 'Synchrony', tier: 3 },
  { name: 'SYNCB', tier: 3 },
  { name: 'Barclays', tier: 3 },
  { name: 'Barclaycard', tier: 3 },
  { name: 'Credit One Bank', tier: 3 },
  { name: 'Credit One', tier: 3 },
  { name: 'Indigo', tier: 3 },
  { name: 'Comenity Bank', tier: 3 },
  { name: 'Comenity', tier: 3 },
  { name: 'First Premier Bank', tier: 3 },
  { name: 'First Premier', tier: 3 },
  { name: 'Credit Union', tier: 3 },
  { name: 'Regional Bank', tier: 3 },
  { name: 'Store Card', tier: 3 },
  { name: 'Merrick Bank', tier: 3 },
  { name: 'Merrick', tier: 3 },
  { name: 'Total Visa', tier: 3 },
  { name: 'Milestone', tier: 3 },
  { name: 'Surge', tier: 3 },
  { name: 'Reflex', tier: 3 },
  { name: 'Fingerhut', tier: 3 },
  { name: 'Aspire', tier: 3 },
  { name: 'OpenSky', tier: 3 },
  { name: 'Applied Bank', tier: 3 },
  { name: 'Applied', tier: 3 },
  { name: 'First Access', tier: 3 },
  { name: 'Fortiva', tier: 3 },
  { name: 'Credit First', tier: 3 },
  { name: 'First National', tier: 3 },
  { name: 'Premier Bankcard', tier: 3 },
  { name: 'Premier', tier: 3 },
  { name: 'Genesis', tier: 3 },
  { name: 'Genesis Financial', tier: 3 },
  { name: 'Avant', tier: 3 },
  { name: 'LendingClub', tier: 3 },
  { name: 'OneMain Financial', tier: 3 },
  { name: 'OneMain', tier: 3 },
  { name: 'Upgrade', tier: 3 },
  { name: 'Self', tier: 3 },
  { name: 'Chime', tier: 3 },
  { name: 'Petal', tier: 3 },
  { name: 'Tommy Hilfiger', tier: 3 },
  { name: 'Victoria\'s Secret', tier: 3 },
  { name: 'Gap', tier: 3 },
  { name: 'Old Navy', tier: 3 },
  { name: 'Banana Republic', tier: 3 },
  { name: 'Best Buy', tier: 3 },
  { name: 'Amazon', tier: 3 },
  { name: 'Walmart', tier: 3 },
  { name: 'Target', tier: 3 },
  { name: 'Kohl\'s', tier: 3 },
  { name: 'Macy\'s', tier: 3 },
  { name: 'Nordstrom', tier: 3 },
  { name: 'Home Depot', tier: 3 },
  { name: 'Lowe\'s', tier: 3 },
  { name: 'Sears', tier: 3 },
  { name: 'JCPenney', tier: 3 },
  { name: 'JC Penney', tier: 3 },
  { name: 'Dillard\'s', tier: 3 },
  { name: 'Belk', tier: 3 },
  { name: 'BJ\'s Wholesale', tier: 3 },
  { name: 'Sam\'s Club', tier: 3 },
  { name: 'Costco', tier: 3 },
  { name: 'PayPal', tier: 3 },
  { name: 'Affirm', tier: 3 },
  { name: 'Klarna', tier: 3 },
  { name: 'Afterpay', tier: 3 },
];

// Helper function to normalize bank name for matching
const normalizeBankName = (name) => {
  if (!name) return '';
  return name
    .toLowerCase()
    .trim()
    // Remove common suffixes and abbreviations
    .replace(/\s+n\.?a\.?$/i, '') // Remove "N.A." or "N.A"
    .replace(/\s+card\s+serv(ices?)?$/i, '') // Remove "CARD SERV" or "CARD SERVICES"
    .replace(/\s+cbna$/i, '') // Remove "CBNA"
    .replace(/\s+na$/i, '') // Remove "NA"
    .replace(/\s+plcc$/i, '') // Remove "PLCC" (Private Label Credit Card)
    .replace(/\s+inc\.?$/i, '') // Remove "INC" or "INC."
    .replace(/\s+llc\.?$/i, '') // Remove "LLC" or "LLC."
    .replace(/\s+corp(oration)?\.?$/i, '') // Remove "CORP" or "CORPORATION"
    .replace(/\s+co\.?$/i, '') // Remove "CO" or "CO."
    .replace(/\s+bank$/i, '') // Remove "BANK" at the end
    .replace(/[^a-z0-9\s]/g, ' ') // Remove special characters
    .replace(/\s+/g, ' ') // Collapse multiple spaces
    .trim();
};

// Helper function to get bank tier by name with flexible matching
export const getBankTier = (bankName) => {
  if (!bankName) return null;
  
  const normalizedInput = normalizeBankName(bankName);
  const lowerInput = normalizedInput.toLowerCase();
  
  // First, try exact match (case-insensitive)
  let bank = banks.find(b => 
    b.name.toLowerCase() === bankName.toLowerCase() ||
    normalizeBankName(b.name) === lowerInput
  );
  
  if (bank) return bank.tier;
  
  // Handle specific known variations and abbreviations first (before partial matching)
  const variations = {
    // Chase variations
    'jpmcb': 'Chase Bank',
    'jpmorgan chase': 'Chase Bank',
    'jpmorgan': 'Chase Bank',
    'jpm': 'Chase Bank',
    'chase': 'Chase Bank',
    'chase bank': 'Chase Bank',
    // Synchrony variations
    'syncb': 'Synchrony Bank',
    'synchrony': 'Synchrony Bank',
    'synchrony bank': 'Synchrony Bank',
    // Citi variations
    'citicards': 'Citibank',
    'citi cards': 'Citibank',
    'citi bank': 'Citibank',
    'citi': 'Citibank',
    // TD Bank variations
    'td bank': 'TD Bank',
    'td': 'TD Bank',
    'toronto dominion': 'TD Bank',
    // Wells Fargo variations
    'wells fargo': 'Wells Fargo',
    'wf': 'Wells Fargo',
    'wfbna': 'Wells Fargo',
    'wellsfargo': 'Wells Fargo',
    // Bank of America variations
    'bank of america': 'Bank of America',
    'boa': 'Bank of America',
    'bofa': 'Bank of America',
    'bankofamerica': 'Bank of America',
    // Capital One variations
    'capital one': 'Capital One',
    'cap one': 'Capital One',
    'capitalone': 'Capital One',
    // American Express variations
    'american express': 'American Express',
    'amex': 'American Express',
    'americanexpress': 'American Express',
    // US Bank variations
    'us bank': 'US Bank',
    'u s bank': 'US Bank',
    'usbank': 'US Bank',
    // Discover variations
    'discover': 'Discover',
    'discover bank': 'Discover',
    'discovercard': 'Discover',
    // Navy Federal variations
    'navy federal': 'Navy Federal Credit Union',
    'navy federal credit union': 'Navy Federal Credit Union',
    'nfcu': 'Navy Federal Credit Union',
    // Amazon/Synchrony
    'amazon': 'Synchrony Bank',
    'syncb amazon': 'Synchrony Bank',
    'amazon plcc': 'Synchrony Bank',
  };
  
  // Sort variations by length (longest first) to match more specific variations first
  const sortedVariationKeys = Object.keys(variations).sort((a, b) => b.length - a.length);
  const variationKey = sortedVariationKeys.find(key => 
    lowerInput.includes(key)
  );
  
  if (variationKey) {
    const matchedBankName = variations[variationKey];
    bank = banks.find(b => b.name === matchedBankName);
    if (bank) return bank.tier;
  }
  
  // Then try partial matching - check if normalized input contains known bank name
  // Only match if the bank name is at least 3 characters to avoid false positives
  bank = banks.find(b => {
    const normalizedBankName = normalizeBankName(b.name);
    if (normalizedBankName.length < 3) return false;
    // Check if input contains the full bank name (more reliable)
    return lowerInput.includes(normalizedBankName);
  });
  
  if (bank) return bank.tier;
  
  // Default to Tier 3 for unknown banks
  return 3;
};

// Helper function to search banks
export const searchBanks = (query) => {
  if (!query || query.trim() === '') return banks;
  const lowerQuery = query.toLowerCase();
  return banks.filter(bank => 
    bank.name.toLowerCase().includes(lowerQuery)
  );
};

// Get banks by tier
export const getBanksByTier = (tier) => {
  return banks.filter(bank => bank.tier === tier);
};

// Get tier display info
export const getTierInfo = (tier) => {
  switch(tier) {
    case 1:
      return {
        label: 'Tier 1',
        description: 'National Premium',
        color: '#f39c12', // Gold/Orange
        bgColor: '#fff3cd',
      };
    case 2:
      return {
        label: 'Tier 2',
        description: 'Regional & Strategic',
        color: '#3498db', // Blue
        bgColor: '#e3f0fc',
      };
    case 3:
      return {
        label: 'Tier 3',
        description: 'Tactical Options',
        color: '#95a5a6', // Gray
        bgColor: '#f8f9fa',
      };
    default:
      return {
        label: 'Unknown',
        description: '',
        color: '#95a5a6',
        bgColor: '#f8f9fa',
      };
  }
};

export default banks;

